import friendship from "../../../image/home/friendship.svg";
import todolist from "../../../image/home/todolist.png";
import graph from "../../../image/home/graph.png";

export const infoSectionData = [
  {
    id: 1,
    img: friendship,
    imgWidth: 48,
    imgHeight: 45,
    title: "یادگیری با دوستان همکلاسی",
    text: "همیشه و همه جا و با هر دستگاهی با آزتو همراه شده و تجربیات لذت‌بخشی داشته باشید. امتیاز جمع کنید، با دوستان خود رقابت کنید و سرگرم باشید.",
  },
  {
    id: 2,
    img: todolist,
    imgWidth: 48,
    title: "تحقق آرزوها",
    text: "با یادگیری هدفمند و عمیق مطالب علمی و درسی، طرز تفکر و نحوه‌ی نگرش خود را تغییر داده و اهداف و آرزوهای خود را تیک بزنید",
  },
  {
    id: 3,
    img: graph,
    imgWidth: 65,
    title: "پیشرفت تحصیلی",
    text: "آزتو یک زمین بازی برای رشد و شکوفایی خلاقیت است. آزمایش‌های جدید طراحی کنید، نتایج طراحی خود را ببینید و پیشرفت کنید.",
    className: "center-icon",
  },
];
